const {
  ModalTest: {
    actions: { toggleModal },
  },
} = window.Edocat.Components;
const {
  ListItem,
  ListItemText,
  ListItemIcon,
  CircularProgress,
  Tooltip,
  ListItemSecondaryAction,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Typography,
  withStyles,
} = window.Material;
const { Check, Error, Block, MoreVert } = window.MaterialIcons;
import { getErrorMessage } from '../../../utils';
import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';

interface UploadRowProps extends ReduxComponentInterface {
  item: any;
  index: number;
  onUpload: Function;
  classes: any;
}

interface UploadRowState {
  anchor: any;
}

const styles = {
  menuItem: {
    height: '2rem',
    padding: '0 10px !important',
    margin: '0 !important',
  },
  text: {
    maxWidth: '300px',
    wordBreak: 'break-all',
  },
  error: {
    color: '#f44336',
  },
  progress: {
    fontSize: '0.6rem !important',
  },
  icon: {
    minHeight: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

class UploadRow extends window.React.PureComponent<UploadRowProps, UploadRowState> {
  constructor(props: UploadRowProps) {
    super(props);
    this.state = {
      anchor: null,
    };
  }

  onMenuOpen = (event: React.ChangeEvent) => {
    this.setState({
      anchor: event.currentTarget,
    });
  };

  onMenuClose = () => {
    this.setState({
      anchor: null,
    });
  };

  onRenameAndUploadBtnClick = () => {
    const { onUpload, index } = this.props;
    onUpload(false, [index], null);
    this.onMenuClose();
  };

  onNewVersionBtnClick = () => {
    const {
      actions,
      item: { file, error },
      onUpload,
      index,
    } = this.props;
    const workingCopyNodeRef = error
      .split(',')
      .find(it => it.includes('workingcopylink'))
      ?.split('_')[1];
    const [nodeRef, name, version] = error.split(',').slice(1);
    const workingCopyName = workingCopyNodeRef
      ? `${name.slice(0, name.lastIndexOf('.'))} (${
          window.Alfresco.messages.global['edocat.document-actions.workingCopy']
        })${name.slice(name.lastIndexOf('.'))}`
      : '';
    actions.toggleModal(true, 'newVersionModal', {
      newFile: file,
      originalFile: {
        nodeRef: workingCopyNodeRef || nodeRef,
        name: workingCopyName || name,
        version,
      },
      onUpload,
      index: index,
      hideInput: true,
    });
    this.onMenuClose();
  };

  render() {
    const {
      item: { file, done, excluded, error, progress },
      classes,
    } = this.props;

    return (
      <React.Fragment>
        <ListItem>
          <ListItemIcon classes={{ root: classes.icon }}>
            {done && (
              <Tooltip title={window.Alfresco.messages.global['edocat.upload.success']}>
                <Check />
              </Tooltip>
            )}
            {error && (
              <Tooltip title={getErrorMessage(error)}>
                <Error className={classes.error} />
              </Tooltip>
            )}
            {excluded && (
              <Tooltip title={window.Alfresco.messages.global['edocat.docDetail.disallowed-extensions.text']}>
                <Block />
              </Tooltip>
            )}
            {progress === -1 && !(done || error || excluded) && <CircularProgress size={30} />}
            {progress !== -1 && !(done || error || excluded) && (
              <Box position="relative" display="inline-flex">
                <CircularProgress size={30} value={progress} variant="determinate" />
                <Box
                  top={0}
                  left={0}
                  bottom={0}
                  right={0}
                  position="absolute"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography
                    classes={{ root: classes.progress }}
                    component="div"
                    color="textSecondary"
                  >{`${progress}%`}</Typography>
                </Box>
              </Box>
            )}
          </ListItemIcon>
          <ListItemText
            primary={file.name}
            classes={error ? { root: `${classes.text} ${classes.error}` } : { root: classes.text }}
          />
          {error && error.includes('file exists') && (
            <ListItemSecondaryAction>
              <Tooltip title={window.Alfresco.messages.global['hybridsync.actions-header-label']}>
                <IconButton onClick={this.onMenuOpen}>
                  <MoreVert />
                </IconButton>
              </Tooltip>
            </ListItemSecondaryAction>
          )}
        </ListItem>
        <Menu anchorEl={this.state.anchor} open={Boolean(this.state.anchor)} onClose={this.onMenuClose}>
          <MenuItem classes={{ root: classes.menuItem }} onClick={this.onRenameAndUploadBtnClick}>
            {window.Alfresco.messages.global['edocat.upload.rename']}
          </MenuItem>
          <MenuItem classes={{ root: classes.menuItem }} onClick={this.onNewVersionBtnClick}>
            {window.Alfresco.messages.global['actions.document.upload-new-version']}
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: window.redux.bindActionCreators({ toggleModal }, dispatch),
});

export default window.reactRedux.connect(null, mapDispatchToProps)(withStyles(styles)(UploadRow));
